module.exports = __webpack_public_path__ + "static/media/Fr.breson.ef9c2de7.png";